import { axiosAuth } from "./axiosAuth"

export const checkSubscriptionStatus = async (platformId, featureId = null) => {
  try {
    const response = await axiosAuth.post(
      "/tokens/check-availability",
      {
        platformId,
        featureId,
      },
      {
        withCredentials: true,
      },
    )

    const data = response.data

    return {
      success: data?.success && data?.canAfford, // Both backend success and canAfford must be true
      canAfford: data?.canAfford,
      usageRemaining: data?.availableTokens,
      requiredTokens: data?.requiredTokens,
      platform: data?.platform,
      featureId: data?.featureId,
      hasFeatureLimits: !!data?.featureId,
      alert: data?.alert || null,
    }
  } catch (err) {
    console.error("Error checking subscription:", err)

    return {
      success: false,
      canAfford: false,
      usageRemaining: 0,
      requiredTokens: 0,
      message: err.response?.data?.message || "Error checking token availability",
      reason: "ERROR",
      alert: null,
    }
  }
}
